import React,{useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookOpen,faCode  } from '@fortawesome/free-solid-svg-icons'
import useHover from '../Hooks/useHover';
import {Link} from 'react-router-dom'


 function Project(props) {
    const [flag,onHover] = useHover(false);   
    const link = "/projects/"+props.p.title;
    
  return (
    <div>
         <a href={props.p.link} target="_blank" rel="noreferrer">
            <div className='Project__container' >
                <div className='Project__header'>
                    <div className='Ribbon'>
                        <span style={{backgroundColor:"#e43f52"}}/>
                        <span style={{backgroundColor:"#f17425"}}/>
                        <span style={{backgroundColor:"#2eca8b"}}/>
                    </div>
                    <div className='Project__title'>
                        {props.p.title}
                    </div>
                </div>
                <div className='Project__box'>

                <img src={props.p.image} alt="Projects_image" onMouseEnter={onHover} />
                {props.p.addOn?
                <img src={props.p.addOn} alt="Addon" className='AddOn'  onMouseEnter={onHover} /> 
                : " "}
                {flag? 
                <div className='cover' onMouseLeave={onHover}>
                     <div className='Project__left'>
                        <Link to={link}><FontAwesomeIcon icon={faBookOpen} className="site"  /></Link>
                    </div>
                    <div className='Project__right'>
                        <a href={props.p.link} target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faCode} className="site"  /></a>
                    </div> 
                </div>
                : " "}
                </div>

                
            </div>
        </a>
    </div>
  )
}

export default Project;
